import React, { createContext, useContext, useCallback, useState } from 'react';

/* Interface do Contexto */
interface ContextProps {
  openModalExplanatory: boolean;
  setOpenModalExplanatory: React.Dispatch<React.SetStateAction<boolean>>;
  openModalResult: boolean;
  setOpenModalResult: React.Dispatch<React.SetStateAction<boolean>>;
  animation0: boolean;
  setAnimation0: React.Dispatch<React.SetStateAction<boolean>>;
  animation1: boolean;
  setAnimation1: React.Dispatch<React.SetStateAction<boolean>>;
  animation2: boolean;
  setAnimation2: React.Dispatch<React.SetStateAction<boolean>>;
  animation3: boolean;
  setAnimation3: React.Dispatch<React.SetStateAction<boolean>>;
  animation4: boolean;
  setAnimation4: React.Dispatch<React.SetStateAction<boolean>>;
  animation5: boolean;
  setAnimation5: React.Dispatch<React.SetStateAction<boolean>>;
  openModalBorderColor: boolean;
  setOpenModalBorderColor: React.Dispatch<React.SetStateAction<boolean>>;
  borderColor: string | null;
  setBorderColor: React.Dispatch<React.SetStateAction<string | null>>;
  defineRowIndex: (index: number) => boolean | undefined;
}

const WordleContext = createContext({} as ContextProps);

const WordleProvider: React.FC = ({ children }) => {
  /* Modais */
  const [openModalExplanatory, setOpenModalExplanatory] = useState(false);
  const [openModalResult, setOpenModalResult] = useState(false);
  const [openModalBorderColor, setOpenModalBorderColor] = useState(false);

  /* Animações */
  const [animation0, setAnimation0] = useState(false);
  const [animation1, setAnimation1] = useState(false);
  const [animation2, setAnimation2] = useState(false);
  const [animation3, setAnimation3] = useState(false);
  const [animation4, setAnimation4] = useState(false);
  const [animation5, setAnimation5] = useState(false);

  /* Cores das bordas dos quadradinhos */
  const [borderColor, setBorderColor] = useState(
    localStorage.getItem('@portalWordle:borderColor')
      ? localStorage.getItem('@portalWordle:borderColor')
      : 'linear-gradient(to top right,rgba(134, 79, 151, 1), rgba(255, 180, 72, 1))'
  );

  const defineRowIndex = useCallback(
    (index: number) => {
      // Função para definir a linha atual
      switch (index) {
        case 0:
          return animation0;
        case 1:
          return animation1;
        case 2:
          return animation2;
        case 3:
          return animation3;
        case 4:
          return animation4;
        case 5:
          return animation5;
      }
    },
    [animation0, animation1, animation2, animation3, animation4, animation5]
  );

  return (
    <WordleContext.Provider
      value={{
        openModalExplanatory,
        setOpenModalExplanatory,
        openModalResult,
        setOpenModalResult,
        animation0,
        setAnimation0,
        animation1,
        setAnimation1,
        animation2,
        setAnimation2,
        animation3,
        setAnimation3,
        animation4,
        setAnimation4,
        animation5,
        setAnimation5,
        openModalBorderColor,
        setOpenModalBorderColor,
        borderColor,
        setBorderColor,
        defineRowIndex,
      }}
    >
      {children}
    </WordleContext.Provider>
  );
};

function useWordle(): ContextProps {
  const context = useContext(WordleContext);

  if (!context) {
    throw new Error('useTimer must be used within an TimerProvider');
  }

  return context;
}

export { WordleProvider, useWordle };
